import { CheckingByLengthType, CheckingByStateType } from './type';

export function shortId() {
  return '_' + Math.random().toString(36).substr(2, 9);
}

export function randomColor() {
  return `hsl(${Math.floor(Math.random() * 360)}, 95%, 90%)`;
}

export function isIndeterminateCheckboxTable<T>(
  check: CheckingByLengthType<T> | CheckingByStateType<T>,
) {
  if (check.type === 'state') {
    const { data, isCheck } = check;
    if (data.length === 0) return false;

    const checkedData = data.filter(isCheck);

    if (checkedData.length === 0) return false;

    return data.length !== checkedData.length;
  } else if (check.type === 'lenght') {
    const { actualData, currentData } = check;
    if (currentData.length === 0 || actualData.length === 0) return false;

    return actualData.length !== currentData.length;
  }
}

export function isCheckedCheckboxTable<T>(
  check: CheckingByLengthType<T> | CheckingByStateType<T>,
) {
  if (check.type === 'state') {
    const { data, isCheck } = check;
    if (data.length === 0) return false;
    const checked = data.every(isCheck);
    return checked;
  } else if (check.type === 'lenght') {
    const { actualData, currentData } = check;
    if (currentData.length === 0 || actualData.length === 0) return false;

    return actualData.length === currentData.length;
  }
}
